<h1 matDialogTitle>{{ title }}</h1>
<mat-dialog-content>
    <div *ngIf="message"
         class="srp-input-dialog__message">{{ message }}</div>
    <mat-form-field [srpAsterisk]>
        <input *ngIf="!multiline"
               matInput
               srpNoAutocomplete
               (keyup.enter)="onPressEnter()"
               [formControl]="control"
               [placeholder]="valueTitle"
               [maxlength]="maxLength">
        <textarea *ngIf="multiline"
                  wrap="hard"
                  class="srp-input-dialog__textarea"
                  matInput
                  [formControl]="control"
                  [placeholder]="valueTitle"
                  [maxlength]="maxLength"
                  rows="22">
        </textarea>

        <mat-error *ngIf="control.hasError('required')">
            {{ requiredErrorMessage || 'Required.' }}
        </mat-error>
        <mat-error *ngIf="control.hasError('maxlength')">
            Length should not exceed {{ maxLength }} characters.
        </mat-error>
        <mat-error *ngIf="control.hasError('uniqueString')">
            This document Name is already being used.
        </mat-error>
        <mat-hint *ngIf="matHintVisible"
                  align="end">
            {{ control.value ? control.value.length : 0 }} / {{ maxLength }}
        </mat-hint>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions [class.center-align]="centerButtonsAlign">
    <button mat-button
            color="accent"
            [disabled]="!control.valid"
            (click)="submit()">{{ submitButton }}</button>
    <button *ngFor="let choice of choices"
            mat-button
            [color]="getColor(choice)"
            (click)="onButtonClick(choice)">{{ getChoice(choice) }}</button>
    <button mat-button
            color="accent"
            (click)="cancel()">Cancel</button>
</mat-dialog-actions>